var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{},[_c('router-link',{staticClass:"page-btn",attrs:{"id":_vm.id,"to":_vm.path,"append":""}},[_vm._t("default")],2),(_vm.info && !_vm.isTouchDevice)?_c('b-tooltip',{attrs:{"target":_vm.id,"triggers":"hover"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.info)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }